import { BellRing, CalendarClock, Check } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const LABELS = {
  quote_followup: "Quote follow-up",
  warranty_expiry: "Warranty expiry",
  warranty_registration: "Warranty registration",
  service_anniversary: "Service anniversary",
  plan_incomplete: "Weekly plan pending",
};

export const RemindersCard = ({ reminders, onAct, showStudio }) => (
  <Card className="border-brand-line shadow-none">
    <CardHeader className="flex-row items-center justify-between space-y-0">
      <CardTitle className="text-lg">Follow-up reminders</CardTitle>
      <Badge data-testid="pending-reminders-count" className="border-0 bg-amber-50 text-amber-700">
        {reminders.filter((r) => r.status === "pending").length} pending
      </Badge>
    </CardHeader>
    <CardContent className="space-y-2" data-testid="reminders-list">
      {reminders.length === 0 && (
        <p className="py-6 text-center text-sm text-slate-500">Nothing needs chasing right now.</p>
      )}
      {reminders.slice(0, 12).map((r) => (
        <div
          key={r.id}
          data-testid={`reminder-${r.id}`}
          className={`flex items-start justify-between gap-3 rounded-md border p-3 ${
            r.status === "acted" ? "border-brand-line bg-slate-50" : "border-amber-200 bg-amber-50/60"
          }`}
        >
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              {r.type === "quote_followup" ? (
                <BellRing className="h-3.5 w-3.5 text-amber-600" strokeWidth={1.8} />
              ) : (
                <CalendarClock className="h-3.5 w-3.5 text-crimson-600" strokeWidth={1.8} />
              )}
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                {LABELS[r.type] || "Service anniversary"}
              </span>
            </div>
            <p className="mt-1 text-sm text-slate-800">{r.message}</p>
            <p className="mt-0.5 text-xs text-slate-500">
              {showStudio ? `${r.studio_name} · ` : ""}
              flagged {fmtDate(r.created_at)}
            </p>
          </div>
          {r.status === "pending" ? (
            onAct && (
              <Button
                size="sm"
                variant="outline"
                data-testid={`act-reminder-${r.id}`}
                onClick={() => onAct(r)}
              >
                Mark actioned
              </Button>
            )
          ) : (
            <Badge className="border-0 bg-emerald-50 text-emerald-700">
              <Check className="mr-1 h-3 w-3" /> Actioned
            </Badge>
          )}
        </div>
      ))}
    </CardContent>
  </Card>
);
